// utils/validation.js

// ✅ Email validation
export const validateEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

// ✅ Mobile validation (Indian numbers: 10 digits, starts with 6-9)
export const validateMobile = (mobile) =>
  /^[6-9]\d{9}$/.test(mobile.trim());

// ✅ Aadhaar validation (12 digits only)
export const validateAadhaar = (aadhaar) =>
  /^\d{12}$/.test(aadhaar.trim());

// utils/validations.js
export const validateAccountNumber = (value) => {
  const trimmed = (value ?? '').trim();
  return /^\d+$/.test(trimmed) && trimmed.length >= 9 && trimmed.length <= 18;
};

export const isAlphabet = (value) => /^[a-zA-Z\s]*$/.test(value);
export const onlyDigits = (value, maxLength = 10) => /^\d{0,10}$/.test(value);

export const validatePassword = (password) => {
    const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[#@$^!%*?&])[A-Za-z\d#@$^!%*?&]{8,}$/;
    return regex.test(password);
};
    
export const validateIfscCode = (value) => {
  // IFSC code must be 11 characters: 
  // 4 uppercase letters (bank), followed by 0, and then 6 alphanumeric characters (branch)
  const isValid = /^[A-Z]{4}0[A-Z0-9]{6}$/.test(value);
  return isValid ? '' : '4 letters (bank) + 0 + 6 alphanumeric (branch)';
}



// ✅ Age validation (must be >= minAge)
export const validateAge = (dob, minAge = 18) => {
  if (!dob) return false;
  const today = new Date();
  const birthDate = new Date(dob);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age >= minAge;
};

// ✅ Future date check
export const validatePastDate = (date) => {
  if (!date) return false;
  return new Date(date) <= new Date();
};

export const capitalizeFirstLetter = (str) => {
  if (!str) return "";
  return str
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};


export const formatAccountHolderName = (str) => {
  if (!str) return "";
  return str.toUpperCase(); // also trim spaces
};

export const formatBranchName = (input) => {
  if (!input) return "";
  let value = input.replace(/[^a-zA-Z\s]/g, "");
  return value
    .split(" ")
    .map(word => word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : "")
    .join(" ");
};


export const formatBankName = (input) => {
  if (!input) return "";
  let value = input.replace(/[^a-zA-Z &-]/g, "");
  return value
    .split(/\s+/)
    .map((word, idx) => {
      if (!word) return "";
      const lower = word.toLowerCase();
      if ((lower === "of" || lower === "and") && idx !== 0) {
        return lower;
      }
      if (word === "&" || word === "-") {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};

export const formatNumber = (value) => {
  if (typeof value === "number" && value >= 1000) {
    return value.toLocaleString("en-IN"); // en-US or en-IN depending on your format
  }
  return value;
}

export const getFileName = (url) => {
  if (!url) return "-";
  const fileName = url.split("/").pop().split("?")[0];
  const lastUnderscore = fileName.lastIndexOf("*");
  return lastUnderscore !== -1 ? fileName.substring(lastUnderscore + 1) : fileName;
};

export const formatTime = (timeStr) => {
  const [hours, minutes] = timeStr.split(':');
  return `${hours}:${minutes}`;
};